import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleIcon from '@mui/icons-material/People';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import PaymentIcon from '@mui/icons-material/Payment';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DiscountIcon from '@mui/icons-material/Discount';
import KeyIcon from '@mui/icons-material/Key';
import PersonIcon from '@mui/icons-material/Person';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CategoryIcon from '@mui/icons-material/Category';

export const pagesInfo = [
    {
        text: "خانه",
        to: "/",
        roles: [1, 2, 3]
    },
    {
        text: "کاربران",
        to: "/users",
        roles: [1, 3]
    },
    {
        text: "سرویس‌ها",
        to: "/services",
        roles: [1, 7]
    },
    {
        text: "پذیرش قطعات",
        to: "/receive-services",
        roles: [2]
    },
    {
        text: "قطعات من",
        to: "/my-services",
        roles: [2]
    },
    {
        text: "امور مالی",
        to: "/financial",
        roles: [2]
    },
    {
        text: "سفارشات",
        to: "/orders",
        roles: [1, 4]
    },
    {
        text: "پرداخت‌ها",
        to: "/payments",
        roles: [1]
    },
    {
        text: "تیکت‌ها",
        to: "/tickets",
        roles: [1, 3]
    },
    {
        text: "تخفیف‌ها",
        to: "/discounts",
        roles: [1]
    },
    {
        text: "ویژگی‌ها",
        to: "/properties",
        roles: [1]
    },
    {
        text: "مواد اولیه",
        to: "/materials",
        roles: [1]
    },
    {
        text: "مدیریت پیمانکارن",
        to: "/manage-contractor",
        roles: [1, 6]
    },
    {
        text: "کنترل کیفیت",
        to: "/quality-control",
        roles: [1, 7]
    },
    {
        text: "تسویه پیمانکاران",
        to: "/contractor-settlement",
        roles: [1, 4]
    },
];

export const submenuItems = [
    {
        text: "تغییر رمز عبور",
        to: "/change-password"
    },
    {
        text: "نمایش اطلاعات",
        to: "/show-profile"
    },
    // {
    //     text: "ویرایش اطلاعات",
    //     to: "/change-profile"
    // },
    {
        text: "خروج",
        to: "/logout"
    }
];

export const hiddenNavbarItems = [
    {
        text: "خانه",
        to: "/",
        icon: <HomeIcon />,
        roles: [1, 2, 3, 4]
    },
    {
        text: "کاربران",
        to: "/users",
        icon: <PeopleIcon />,
        roles: [1, 3, 4]
    },
    {
        text: "سرویس‌ها",
        to: "/services",
        icon: <MedicalInformationIcon />,
        roles: [1, 2]
    },
    {
        text: "سفارشات",
        to: "/orders",
        icon: <AddShoppingCartIcon />,
        roles: [1, 2, 4]
    },
    {
        text: "پرداخت‌ها",
        to: "/payments",
        icon: <PaymentIcon />,
        roles: [1, 4]
    },
    {
        text: "تیکت‌ها",
        to: "/tickets",
        icon: <ConfirmationNumberIcon />,
        roles: [1, 2, 3, 4]
    },
    {
        text: "تخفیف‌ها",
        to: "/discounts",
        icon: <DiscountIcon />,
        roles: [1, 4]
    },
    {
        text: "ویژگی‌ها",
        to: "/properties",
        icon: <AppRegistrationIcon />,
        roles: [1]
    },
    {
        text: "مواد اولیه",
        to: "/materials",
        roles: [1],
        icon: <CategoryIcon />
    },
];

export const collapsedListItems = [
    {
        text: "تغییر رمز عبور",
        to: "/change-password",
        icon: <KeyIcon />
    },
    {
        text: "نمایش اطلاعات",
        to: "/show-profile",
        icon: <PersonIcon />
    },
    {
        text: "ویرایش اطلاعات",
        to: "/change-profile",
        icon: <ManageAccountsRoundedIcon />
    },
    {
        text: "خروج",
        to: "/logout",
        icon: <LogoutIcon />
    }
];
